import styled, { css } from 'styled-components';
import {
  SCREEN_SIZE,
  SCREEN_SIZE_WIDTH,
  SCREEN_SIZE_MAX_WIDTH
} from 'utils/Constants';

export const clearfix = `
  &::after{
    content: "";
    display: table;
    clear: both;
  }
`;

export const media = {
  [SCREEN_SIZE.XS]: (...args) => css`
    @media (max-width: ${SCREEN_SIZE_MAX_WIDTH[SCREEN_SIZE.SM]}px) {
      ${css(...args)}
    }
  `,
  [SCREEN_SIZE.SM]: (...args) => css`
    @media (min-width: ${SCREEN_SIZE_WIDTH[SCREEN_SIZE.SM]}px) {
      ${css(...args)}
    }
  `,
  [SCREEN_SIZE.MD]: (...args) => css`
    @media (min-width: ${SCREEN_SIZE_WIDTH[SCREEN_SIZE.MD]}px) {
      ${css(...args)}
    }
  `,
  [SCREEN_SIZE.LG]: (...args) => css`
    @media (min-width: ${SCREEN_SIZE_WIDTH[SCREEN_SIZE.LG]}px) {
      ${css(...args)}
    }
  `,
  [SCREEN_SIZE.XL]: (...args) => css`
    @media (min-width: ${SCREEN_SIZE_WIDTH[SCREEN_SIZE.XL]}px) {
      ${css(...args)}
    }
  `
};

export function svgColor(svg: any, fillColor: string) {
  if (svg && fillColor) {
    let fill = css`
      & > path {
        fill: ${fillColor};
      }
    `;
    return styled(svg)`
      ${fill}
    `;
  }
  return svg || styled.svg``;
}
